import GSAP from 'gsap';
import Page from '@averyano/core/src/classes/Page';
import ScrollTrigger from 'gsap/ScrollTrigger';
import each from 'lodash/each';

import FaqSection from '../Home/FaqSection';

export default class ProductPage extends Page {
	constructor(el) {
		super({
			element: '.product',
			elements: {
				wrapper: '.product__wrapper',
				mainImg: '.product__main-img',
				mainVideo: '.product__main-video',
				thumbs: '.product__thumb',
			},
		});

		this.id = 'product';
		this.isCreated = false;
		this.currentProduct = null;
		this.onThumbClick = [];
	}

	create() {
		if (this.template !== this.id) return;
		if (!this.isReady) super.createComponent();
		if (!this.isCreated) {
			this.components = {
				faq: new FaqSection({ opened: false }),
			};
			this.isCreated = true;
		}

		each(this.components, (component) => {
			component.create();
			if (component.addEventListeners) component.addEventListeners();
		});

		super.create();

		this.itemId = this.element.dataset.id;
		this.currentProduct = PRODUCTS.find((p) => p.id === this.itemId);

		this.addEventListeners();
	}

	selectThumb(thumb) {
		if (!this.elements.mainImg) return;
		const type = thumb.dataset.type || 'image';

		if (type === 'video' && this.elements.mainVideo) {
			this.elements.mainImg.classList.add('hidden');
			this.elements.mainVideo.classList.remove('hidden');
			this.elements.mainVideo.src = thumb.dataset.src;
			this.elements.mainVideo.play();
		} else {
			if (this.elements.mainVideo) {
				this.elements.mainVideo.pause();
				this.elements.mainVideo.removeAttribute('src');
				this.elements.mainVideo.load();
				this.elements.mainVideo.classList.add('hidden');
			}
			this.elements.mainImg.src = thumb.dataset.src;
			this.elements.mainImg.alt = thumb.dataset.alt || '';
			this.elements.mainImg.classList.remove('hidden');
		}

		each(this.elements.thumbs, (t) => t.classList.remove('active'));
		thumb.classList.add('active');
	}

	destroy() {
		this.scrollTrigger?.kill();
		this.removeEventListeners();
		this.elements.mainVideo?.pause();
		each(this.components, (component) => component.destroy && component.destroy());
		super.destroy();
	}

	show() {
		GSAP.to(this.element, {
			autoAlpha: 1,
			duration: 1.5,
			ease: 'power2.out',
		});

		window.scrollTo(0, 0);
	}

	hide() {
		return new Promise((resolve) => {
			this.elements.mainVideo?.pause();
			ScrollTrigger.getAll().forEach((t) => t.kill());
			GSAP.to(this.element, {
				autoAlpha: 0,
				duration: 1.5,
				ease: 'expo.out',
				onComplete: resolve,
			});
		});
	}

	update() {}

	addEventListeners() {
		if (!this.elements.thumbs || !this.elements.thumbs.length) return;

		each(this.elements.thumbs, (thumb) => {
			const handler = () => this.selectThumb(thumb);
			this.onThumbClick.push({ thumb, handler });
			thumb.addEventListener('click', handler);
		});
	}

	removeEventListeners() {
		each(this.onThumbClick, ({ thumb, handler }) => {
			thumb.removeEventListener('click', handler);
		});
		this.onThumbClick = [];
	}
}
